import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpErrorResponse, HttpEvent } from '@angular/common/http';
import { Store, select } from '@ngrx/store';
import { State } from '../../store/main';
import { catchError } from 'rxjs/operators';
import { Logout } from '../../store/auth/actions';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ErrorInterceptor implements HttpInterceptor {
  public constructor(private store: Store<State>) {}

  public intercept<RQ = any>(
    req: HttpRequest<RQ>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(catchError(this.handleError));
  }

  private handleError = (error: any) => {
    if (error.error instanceof ErrorEvent) {
      this.handleClientOrNetworkError(error.error);
    } else {
      this.handleBackendError(error);
    }

    throw error;
  };

  /**
   * Handle a client-side or network error.
   * This means the request never made it to the server.
   *
   * @param error ErrorEvent
   */
  private handleClientOrNetworkError = (error: ErrorEvent) => {
    console.error(error.message); // TODO: handle
    return;
  };

  /**
   * Handle backend/server error.
   * This means the request was handled by the backend
   * and an error response was returned.
   *
   * @param error HttpErrorResponse
   */
  private handleBackendError = (error: HttpErrorResponse) => {
    switch (error.status) {
      case 401:
        if (error.error && error.error.code === 'ErrTokenExpired') {
          return this.store.pipe(select('auth', 'accessToken')).subscribe({
            next: (accessToken) => {
              this.store.dispatch(new Logout());
            },
          });
        }

      default:
        // we are really only interested in handling token expiration error
        // here; everything else should be handled by the original caller as
        // they have more context on the error.
        console.error(error.error);
        return;
    }
  };
}
